<script>
import HomePageBanner from './ISEF/HomePageBanner'
import FinalistBanner from './ISEF/FinalistBanner'

export default {
  components: {
    HomePageBanner,
    FinalistBanner
  },
  computed: {
    isExplorer: function () {
      return this.$route.name === 'viewAll'
    },
    isHome: function () {
      return this.$route.name === 'home'
    }
  }
}
</script>

<template>
  <HomePageBanner v-if="!isExplorer && !isHome"/>
  <FinalistBanner v-else />
</template>
